const ROLE_PERMISSIONS: Record<string, string[]> = {
  campaign_manager: [
    'campaigns.read',
    'campaigns.write',
    'campaigns.delete',
    'campaigns.launch',
    'stats.read',
    'content.generate',
  ],
  campaign_viewer: ['campaigns.read', 'stats.read'],
};

export function hasPermission(roles: string[] | undefined, permission: string): boolean {
  if (!roles) return false;
  return roles.some((role) => ROLE_PERMISSIONS[role]?.includes(permission) ?? false);
}
